import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { Injector, NgModule, inject, provideAppInitializer } from '@angular/core';
import { MyShopInterceptor } from './adapters/my-shop.interceptor';
import { MyShopService } from './services';

export function initFactory(injector: Injector): () => void {
  return () => {
    const myShopService = injector.get(MyShopService);
    myShopService.init();
  };
}

@NgModule({
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useExisting: MyShopInterceptor,
      multi: true,
    },
    provideAppInitializer(() => {
      const initializerFn = initFactory(inject(Injector));

      return initializerFn();
    }),
  ],
})
export class MyShopFeatureModule {}
